export const INDIVIDUAL = {
  id: 'individual',
  label: 'Individual'
}

export const SINGLE_USER = {
  id: 'singleUser',
  label: 'Single user'
}

export const STANDARD_BUSINESS = {
  id: 'standardBusiness',
  label: 'Standard business'
}

export const LAWYER = {
  id: 'lawyer',
  label: 'Lawyer'
}

export const ADVISER = {
  id: 'adviser',
  label: 'Adviser'
}

export const ADMIN = {
  id: 'admin',
  label: 'Admin'
}

const ACCOUNT_TYPES_LIST = [
  ADMIN,
  ADVISER,
  INDIVIDUAL,
  LAWYER,
  SINGLE_USER,
  STANDARD_BUSINESS
]

const ACCOUNT_TYPE_LOOKUP = ACCOUNT_TYPES_LIST.reduce(
  (acc, accountType) => ({ ...acc, [accountType.id]: accountType }),
  {}
)

export const getAccountType = (accountTypeId) => {
  const accountType = ACCOUNT_TYPE_LOOKUP[accountTypeId]
  if (!accountType) {
    throw new Error(`Unknown account type "${accountTypeId}"`)
  }
  return accountType
}

const isAccountType =
  ({ id }) =>
    (accountTypeId) =>
      id === accountTypeId

export const isAdminAccount = isAccountType(ADMIN)
export const isAdviserAccount = isAccountType(ADVISER)
export const isIndividualAccount = isAccountType(INDIVIDUAL)
export const isLawyerAccount = isAccountType(LAWYER)
export const isSingleUserAccount = isAccountType(SINGLE_USER)
export const isStandardBusinessAccount = isAccountType(STANDARD_BUSINESS)

export const isStandardAccount = (accountTypeId) =>
  isSingleUserAccount(accountTypeId) || isStandardBusinessAccount(accountTypeId)

export const listAllAccountTypes = () => ACCOUNT_TYPES_LIST
